<template>
  <div class="home">
    <RequestPage />
      <div v-if="loading && !showModal" class="loader-container">
        <img
          v-show="loading"
          class="loader"
          src="@/assets/images/global/loader.gif"
          alt=""
        />
      </div>

    <div id="requestKitsModal" v-if="showModal">
      <h2>Sun Hero HQ Alert!</h2>
      <p>We are currently fresh out of kits but don’t worry, we’re restocking our super supplies.</p>
      <p>Check back soon to place your order!</p>
      <p><button @click="goBackHome">
        CLOSE <span><i class="fas fa-times"></i></span>
      </button></p>
    </div>

    <div v-if="introModal" id="introModal" class="mb-3">
      <button class="intro-modal-close" @click="closeIntroModal">
        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
          <circle cx="22.5" cy="22.5" r="22.5" fill="#F58220"/>
          <path d="M15 14L31 30" stroke="#003767" stroke-width="3" stroke-linecap="round"/>
          <path d="M31 14L15 30" stroke="#003767" stroke-width="3" stroke-linecap="round"/>
        </svg>
      </button>

      <div class="intro-modal-image">
        <img src="@/assets/images/super-simon-sunhero.png" alt="Super Simon Sun Hero" class="intro-image-main">
      </div>

      <div class="intro-modal-content">
        <h2>THANKS FOR BEING A SUN HERO!</h2>
        <p>Heads up, Sun Heroes! Our sun safety kits are in higher demand than ever. To make sure there are enough kits to go around, we have updated our ordering process.</p>
        <p><strong>Our sun safety kits are now available to request on a quarterly basis—first come, first serve.</strong> Come back each quarter to order more kits—and keep your students covered!</p>
      </div>

      <img src="@/assets/images/super-simon-sunhero.png" alt="Super Simon Sun Hero" class="intro-image-mobile">
    </div>

    <div class="overlay" v-if="showModal || introModal"></div>
  </div>
</template>

<script>
import RequestPage from '../components/elements/pages/RequestPage.vue'

const INTRO_MODAL_SESSION_KEY = 'introModalShown'

export default {
  name: 'Request',
  metaInfo: {
    title: 'Request Kits'
  },
  components: {
    RequestPage
  },
  data () {
    return {
      showModal: false,
      introModal: false,
      loading: false
    }
  },
  created () {
    this.showIntroModalOncePerSession()
    this.getInitial()
  },
  mounted () {
    // this.showModal = true
  },
  methods: {
    goBackHome () {
      this.showModal = false
      this.$router.push({ name: 'HomeLoggedIn' })
    },
    showIntroModalOncePerSession () {
      if (!sessionStorage.getItem(INTRO_MODAL_SESSION_KEY)) {
        this.introModal = true
        sessionStorage.setItem(INTRO_MODAL_SESSION_KEY, '1')
      }
    },
    closeIntroModal () {
      this.introModal = false
    },
    getInitial () {
      this.loading = true
      this.axios
        .get(this.$apiUrl + 'v1/admin/options/get')
        .then((response) => {
          if (response.data) {
            const d = response.data.data
            this.showModal = d.disable_educator_kit === '1' && d.disable_student_kit === '1'
          }
          this.loading = false
        })
        .catch(() => {
          this.showModal = true
          this.loading = false
        })
    }
  }

}
</script>
<style scoped lang="less">
@import (reference) "~@/assets/css/variables.less";
section.home-hero {
  background-size: 100% 100%;
  padding: 0;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
  }
}
#requestKitsModal {
  position: fixed;
  text-align: center;
  top: 200px;
  width: 80%;
  max-width: 95%;
  max-height: 95%;
  left: 50%;
  margin-left: -40%;
  padding: 30px 30px 60px 30px;
  z-index: 1000;
  border-radius: 10px;
  background-color: white;
  box-shadow: #110f2e 0 0 10px;
  @media screen and (max-width: 768px) {
    width: 90%;
    top: 50px;
    margin-left: -45%;
  }
  transition: all 0.3s ease;
  h2 {
    margin-bottom: 2em;
  }
}
#introModal {
  position: fixed;
  display: flex;
  align-items: center;
  gap: 37px;
  background-color: @color-dk-blue;
  text-align: left;
  top: 25%;
  width: 932px;
  left: 50%;
  margin-left: calc(932px / -2);
  padding: 25px;
  z-index: 1000;
  box-sizing: border-box;

  .intro-modal-close {
    position: absolute;
    right: 25px;
    top: 25px;
    width: 45px;
    height: 45px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    cursor: pointer;
    line-height: 0;
  }

  .intro-modal-image {
    flex: 0 0 269px;
  }

  .intro-modal-content {
    flex: 1;
    margin: 55px 120px 50px 0;
  }

  h2 {
    color: white;
    font-family: @font-1;
    font-size: 40px;
    font-weight: normal;
    line-height: 1.1;
    padding-bottom: 31px;
    margin: 0;
  }

  p {
    color: white;
    font-size: 18px;
    line-height: 1.25;
    margin: 0 0 20px;
  }

  .intro-image-main {
    display: block;
    width: 269px;
    height: 280px;
  }

  .intro-image-mobile {
    display: none;
  }

  @media screen and (max-width: 940px) {
    display: block;
    top: 50px;
    width: 90%;
    left: 5%;
    margin-left: 0;
    padding: 85px 30px 30px;

    .intro-modal-content {
      margin: 0;
    }

    .intro-modal-image {
      display: none;
    }

    .intro-image-main {
      display: none;
    }

    .intro-image-mobile {
      display: block;
      width: auto;
      height: inherit;
      margin: 0 auto;
    }
  }
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
  transition: all 0.3s ease;
}
.loader-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  z-index: 999;
}
.loader {
  height: 50px;
  width: 50px;
  margin-top: 35%;
}
</style>
